module.exports = __webpack_public_path__ + "static/media/1POLICY36.fab6c9e5.jpg";